<template>
  <div class="operation-panel bg-transparent rounded-2px z-99 w-full h-full">
    <div
      class="w-20px h-30px absolute -right-18px top-70px iconfont text-[#fff] bg-[#3636366b] text-center leading-30px"
      :class="CrossSectionShow ? 'icon-line-left' : 'icon-line-right'"
      @click="crossShowtoggle"
    ></div>
    <el-row :gutter="10" class="pr-5px">
      <div class="operate-handle-wrap flex items-center">
        <div
          class="operate-handle-btn leading-30px w-30px h-30px ml-10px text-center rounded-1/2 text-[#fff]"
          :class="{ 'is-active': activeType === 1 }"
        >
          <el-tooltip effect="dark" content="移动" placement="top">
            <span @click="operateClip(1)" class="iconfont icon-yxr-move"></span>
          </el-tooltip>
        </div>
        <div
          class="operate-handle-btn leading-30px w-30px h-30px ml-10px text-center rounded-1/2 text-[#fff]"
          :class="{ 'is-active': activeType === 2 }"
        >
          <el-tooltip effect="dark" content="旋转" placement="top">
            <span @click="operateClip(2)" class="iconfont icon-yxr-rotate"></span>
          </el-tooltip>
        </div>
        <div
          class="operate-handle-btn leading-30px w-30px h-30px ml-10px text-center rounded-1/2 text-[#fff]"
          :class="{ 'is-active': activeType === 3 }"
        >
          <el-tooltip effect="dark" content="缩放" placement="top">
            <span @click="operateClip(3)" class="iconfont icon-yxr-zoom"></span>
          </el-tooltip>
        </div>
        <el-color-picker
          color-format="hex"
          @change="changeColor"
          class="ml-10px"
          v-model="currentColor"
        ></el-color-picker>
        <el-switch
          v-model="activeClip"
          @change="changeActive"
          active-text="启动剖面"
          inactive-text="取消剖面"
          active-color="#45f2eb"
          class="ml-10px"
        ></el-switch>
      </div>
      <div class="flex items-center py-10px">
        <el-button
          @click="getPipeData"
          size="mini"
          type="primary"
          class="ml-10px"
          v-loading="loading"
          >生成断面</el-button
        >
        <el-button
          @click="exportFile"
          size="mini"
          type="primary"
          class="ml-10px"
          :disabled="!tabList.length || !CrossSectionShow"
          v-loading="exportLoading"
        >
          导出
        </el-button>
      </div>
    </el-row>
    <el-tabs v-model="activeName" type="card" class="tab-tab-warp" v-loading="tabLoading">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="getTabName(index)"
        :name="getTabName(index)"
      >
        <el-table
          :ref="`markerTable${index}`"
          :data="item"
          height="100%"
          border
          :row-key="(row) => row.recordIndex"
          class="w-full"
          :current-row-key="currentItem"
          @row-click="(row) => clickRow(row)"
          :highlight-current-row="true"
        >
          <el-table-column
            show-overflow-tooltip
            prop="serialNumber"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="code" label="管道编码"></el-table-column>
          <el-table-column show-overflow-tooltip prop="name" label="管道名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="medium" label="介质"></el-table-column>
          <el-table-column show-overflow-tooltip prop="pressure" label="压力"></el-table-column>
          <el-table-column show-overflow-tooltip prop="diameter" label="直径"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  find,
  some,
  map,
  min,
  max,
  uniqBy,
  filter,
  includes,
  flatMap,
  isObject,
  compact,
  isNil,
  isEmpty,
  forEach,
} from 'lodash'
import * as ExcelJS from 'exceljs'
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'
import EventBus from './EventBus'

const threeDimensionsApi = new ThreeDimensionsApi()
export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    CrossSectionShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabLoading: false,
      exportLoading: false,
      currentColor: '',
      activeName: '一层',
      currentItem: null,
      loading: false,
      activeType: 0,
      clipObject: null,
      tableSearch: null,
      activeClip: false,
      lastIndex: -1,
      classOptions: [],
      tagList: [],
      mediumList: [],
      lastResData: [], // 最终整理的需渲染的数据
      // displayList: [],
      tabList: [], // 标签页详情
      allData: [], // 全部管线数据
    }
  },
  beforeDestroy() {
    this.player.Native.ClipBox.inactiveClipObject()
    this.player.Native.ClipBox.setEnabled(false)
    this.player.Native.NodeEditor.setNode('nullptr')
    this.player.Native.NodeEditor.setEditType(0)
    this.player.Native.ModelTree.setSelectItem(0)
    EventBus.$off('crossMarkClick', this.crossMarkClick)
  },
  async created() {
    EventBus.$on('crossMarkClick', this.crossMarkClick)
    this.getMediumList()
    // 如果打开功能时已经选中了设备
    if (this.selectedTag) {
      this.tagList = []
    }
    this.clipObject = await this.player.Native.ClipBox.activeClipPanel()
    const anchorPos = await player.Native.Camera.getAnchorPos()
    const currentParam = await player.Native.Camera.currentParam()
    this.player.Native.ClipBox.clipPanelInitByPoint(
      this.clipObject,
      anchorPos,
      Vec3.sub(currentParam.eye, anchorPos),
      [20, 20]
    )
    this.player.Native.NodeEditor.setNode(this.clipObject)
    this.player.Native.ClipBox.setEnabled(false)
  },
  methods: {
    // 图表点击交互
    crossMarkClick({ param, lastIndex }) {
      let levelIndex = 0
      const tempIndex = _.findIndex(this.allData, ['code', param.data.code])
      if (tempIndex > -1) {
        levelIndex = this.allData[tempIndex].level
      }
      this.activeType = 0
      this.player.Native.NodeEditor.setEditType(0)
      this.player.Native.ModelTree.setSelectItem(0)
      this.activeClip = false
      this.player.Native.ClipBox.setEnabled(false)
      this.player.Native.Camera.moveToItem(param.data.item, 2)
      this.player.Native.ModelTree.setSelectItem(param.data.item)
      this.currentItem = param.data.recordIndex
      this.tableScrollToRow(param.data.serialNumber, levelIndex)
      this.lastIndex = lastIndex
    },
    // 图表弹窗显隐切换
    crossShowtoggle() {
      const filterEvent = new CustomEvent('gxDialogControl', {
        detail: {
          status: !this.CrossSectionShow,
          type: 'toggle',
          currentDialog: 'CrossSectionChart',
        },
      })
      window.dispatchEvent(filterEvent)
    },
    // 获取层级名称
    getTabName(index) {
      const levelName = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      return `${levelName[index]}层`
    },
    getTabNameLineFeed(index) {
      const levelName = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      return `${levelName[index]}\n\n层`
    },
    // 获取当前高度，占总高度百分比
    getPercentage(maxHeight, currentHeight) {
      const percent = Number(((maxHeight - currentHeight) / maxHeight).toFixed(2)) * 100
      return `${percent - 2}%`
    },
    // 获取介质列表
    async getMediumList() {
      const [err, res] = await threeDimensionsApi.getSysDatat({
        parentKey: 'Medium',
      })
      if (!err && res?.code && res.code === '200' && res.data) {
        this.mediumList = res.data
      }
    },
    /**
     * @description 点击隐藏
     */
    clickHide() {
      this.$emit('hideComponent')
    },
    // 关闭面板
    closePanel() {
      this.$emit('closePanel')
    },
    /**
     * @description 导出文件
     */
    exportFile() {
      try {
        this.exportLoading = true
        if (this.lastIndex !== -1) {
          EventBus.$emit('crossChartMarkHighLight', {
            index: -1,
            lastIndex: this.lastIndex,
          })
          this.lastIndex = -1
        }
        const workBook = new ExcelJS.Workbook()
        const workSheet = workBook.addWorksheet('sheet1')
        const row = workSheet.getRow(1)
        const column2 = workSheet.getColumn(2)
        const column3 = workSheet.getColumn(3)
        column2.width = 34
        column3.width = 34
        row.height = 375
        let rowIndex = 2 // 行数字
        for (let i = 0; i < this.tabList.length; i += 1) {
          const currentLevelName = this.getTabName(i)
          const cell = workSheet.getCell(`A${rowIndex}`)
          workSheet.mergeCells(`A${rowIndex}:F${rowIndex}`) // 合并单元格
          cell.value = currentLevelName
          cell.alignment = { vertical: 'middle', horizontal: 'center' } // 剧中
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '2294fb' } } // 添加背景色
          workSheet.addRow(['序号', '管道编码', '管道名称', '介质', '压力', '直径'])
          const exportData = _.map(this.tabList[i], (it) => {
            return [it.serialNumber, it.code, it.name, it.medium, it.pressure, it.diameter]
          })
          workSheet.addRows(exportData)
          rowIndex = rowIndex + this.tabList[i].length + 2
        }
        EventBus.$emit('crossChartExport', { workBook, workSheet })
        this.exportLoading = false
      } catch (error) {
        console.error(error)
        this.exportLoading = false
      }
    },
    base64ToBlob(data) {
      const bstr = atob(data)
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      // eslint-disable-next-line no-plusplus
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: 'image/png',
      })
    },
    convertTo0xFormat(color) {
      if (color.startsWith('#')) {
        color = color.slice(1)
      }
      return parseInt(`0x${color}30`, 16)
    },

    /**
     * @description 切换颜色
     */
    changeColor(val) {
      this.player.Native.ClipBox.clipObjectSetFrontColor(
        this.clipObject,
        this.convertTo0xFormat(val)
      )
    },

    /**
     * @description 点击表格行
     */
    clickRow(val) {
      this.activeType = 0
      this.player.Native.NodeEditor.setEditType(0)
      this.player.Native.ModelTree.setSelectItem(0)
      this.activeClip = false
      this.player.Native.ClipBox.setEnabled(false)
      this.player.Native.Camera.moveToItem(val.item, 2)
      this.player.Native.ModelTree.setSelectItem(val.item)
      this.currentItem = val.recordIndex
      const index = _.findIndex(this.lastResData, ['item', val.item])
      EventBus.$emit('crossChartMarkHighLight', {
        index,
        lastIndex: this.lastIndex,
      })
      this.lastIndex = index
    },

    /**
     *  el-table滚动到表格某一行
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     * @param {Number} index   层数index
     */
    tableScrollToRow(rowIndex, index) {
      this.activeName = this.getTabName(index)
      this.$nextTick(() => {
        const bodyWrap = this.$refs[`markerTable${index}`][0].$el.querySelectorAll(
          '.el-table__body-wrapper'
        )
        if (!bodyWrap) return
        const tableBody = this.$refs[`markerTable${index}`][0].bodyWrapper.querySelectorAll(
          '.el-table__body-wrapper .el-table__body tbody'
        )
        if (!tableBody) return
        const rowDom = tableBody[0].children[rowIndex]
        if (!rowDom) return
        bodyWrap[0].scrollTop = rowDom.offsetTop - 42
      })
    },
    // 关闭弹窗
    closeComponent() {
      this.player.Native.ClipBox.inactiveClipObject()
      this.player.Native.ClipBox.setEnabled(false)
      this.player.Native.NodeEditor.setNode('nullptr')
      this.player.Native.NodeEditor.setEditType(0)
      this.player.Native.ModelTree.setSelectItem(0)
      this.$emit('closeComponent', 'CrossSectionAnalysis')
    },
    /**
     * @description 操作剖面
     * @param type 0无类型 1移动 2旋转 3缩放
     */
    async operateClip(type) {
      this.activeType = type
      const operateType = await this.player.Native.NodeEditor.editType()
      this.player.Native.ModelTree.setSelectItem(0)
      if (operateType === type) {
        this.activeType = 0
        this.player.Native.NodeEditor.setEditType(0)
      } else {
        await this.player.Native.NodeEditor.setEditType(type)
      }
    },

    /**
     * @descrption 切换剖面
     */
    changeActive(val) {
      this.player.Native.ClipBox.setEnabled(val)
    },
    // 接口接入管线属性
    async getPipeProperty(res) {
      const codes = _.map(res, (item) => {
        return item.code
      })
      let pipeData = []
      const [err, result] = await threeDimensionsApi.getPipeLineList({
        body: {
          pageNo: 1,
          pageSize: 999,
          code: '',
          codes,
        },
      })
      if (!err && result && result.code === '200' && result.data?.items) {
        pipeData = result.data.items
      }

      const finalRes = map(res, (item) => {
        const index = _.findIndex(pipeData, ['code', item.code])
        if (index > -1) {
          return {
            ...item,
            medium: this.getMediumName(pipeData[index].medium),
            pressure: pipeData[index].pressure,
            diameter: pipeData[index].nominalSize,
          }
        }
        return {
          ...item,
          medium: '',
          pressure: null,
          diameter: null,
        }
      })
      return finalRes
    },
    // 通过key获取介质名称
    getMediumName(key) {
      const index = _.findIndex(this.mediumList, ['key', key])
      if (index > -1) {
        return this.mediumList[index].value
      }
      return ''
    },
    /**
     * @description 获取管道数据
     */
    async getPipeData() {
      this.tabLoading = true
      try {
        this.tabList = []
        this.allData = []
        this.loading = true
        this.activeType = 0
        this.lastIndex = -1
        this.player.Native.NodeEditor.setEditType(0)
        let res = await this.player.Native.ClipBox.getPanelClipInstance(this.clipObject)
        this.loading = false
        if (!this.CrossSectionShow) {
          const filterEvent = new CustomEvent('gxDialogControl', {
            detail: {
              status: true,
              type: 'open',
              currentDialog: 'CrossSectionChart',
            },
          })
          window.dispatchEvent(filterEvent)
        }
        if (res) {
          // 横坐标排序
          res = res.sort((a, b) => {
            return a.center2d[0] - b.center2d[0]
          })
          // 相同位号过滤
          res = uniqBy(res, 'code')
          // 为显示内容剧中，数据点距左侧空白距离控制在0.2(图标左侧固定最小)
          const minPipeLeft = min(
            map(res, (it) => {
              return it.center2d[0] - it.radians // 中心点减去当前半径为左侧距离
            })
          )
          if (minPipeLeft !== 0.1) {
            const dif = 0.1 - minPipeLeft
            forEach(res, (item) => {
              item.center2d[0] += dif
            })
          }
          // 为了体现管廊高度，统一留出管廊位置(图表底部固定最小值2)
          const minPipeHeight = min(
            map(res, (it) => {
              return it.center2d[1]
            })
          )
          if (minPipeHeight !== 4) {
            const dif = 2 - minPipeHeight
            forEach(res, (item) => {
              item.center2d[1] += dif
            })
          }
          // 为使内容充分占用图标，最顶部管线边缘距离图表顶部固定0.5(图表顶部固定最小值, 通过给y轴设置最大值实现)
          const maxPipeHeight = max(
            map(res, (it) => {
              return it.center2d[1] + it.radians // 最高管线中心，加上其半径为到顶部高度
            })
          )
          const chartMaxHeight = maxPipeHeight + 0.5
          // 统一对过粗管线和过细管线做处理
          forEach(res, (item) => {
            if (item.radians > 0.6) {
              item.radians = 0.5
            } else if (item.radians > 0.5 && item.radians <= 0.6) {
              item.radians = 0.4
            } else if (item.radians < 0.05) {
              item.radians = 0.05
            }
          })
          // 此处预留后续接口接入数据属性
          res = await this.getPipeProperty(res)
          // 通过高度排序，差值大于1.4米的，则绘制一条横线代表管廊 -start
          const sortHeight = map(res, (it) => {
            return it.center2d[1]
          }).sort((a, b) => {
            return a - b
          })
          const lineValArr = []
          for (let i = 1; i < sortHeight.length; i += 1) {
            const dif = sortHeight[i] - sortHeight[i - 1]
            if (dif > 1.4) {
              lineValArr.push((sortHeight[i] + sortHeight[i - 1]) / 2)
            }
          }
          const markLineData = map(lineValArr, (it) => {
            return {
              yAxis: it,
            }
          })
          // 给图表添加层级标注
          const markCollectionWithName = await this.addLevelMark(chartMaxHeight, res, lineValArr)
          // 按最新规则给数据排序
          const { dataWithOrder, result } = await this.dataSorting(res, lineValArr)
          _.forEach(res, (item) => {
            const withOrderIndex = _.findIndex(result, ['code', item.code])
            if (withOrderIndex > -1) {
              item.serialNumber = result[withOrderIndex].serialNumber
              item.level = result[withOrderIndex].level
            }
          })
          this.tabList = dataWithOrder
          this.allData = result
          // 通过高度排序，差值大于1.5米的，则绘制一条横线代表管廊 -end
          const pipeItems = _.map(res, (i) => {
            return i.item
          })
          _.forEach(res, (i, index) => {
            i.radians = i.radians.toFixed(2)
            i.index = index
          })
          _.forEach(res, (i, index) => {
            i.recordIndex = `${i.item}index${index}`
          })
          this.lastResData = res
          EventBus.$emit('createCrossSection', {
            chartMaxHeight,
            markLineData,
            markCollectionWithName,
            res,
          })
        }
        this.tabLoading = false
      } catch (error) {
        this.tabLoading = false
      }
    },
    /**
     * @description 按最新要求，给数据排序
     * @param {Array} res 管线全量数据
     * @param {Array} lineValArr 图表中画的横线高度集合
     */
    dataSorting(res, lineValArr) {
      const stratifyData = [] // 分层后的数据
      let lastVal = 0 // 上一层分割线数值
      // 先将管线数据根据横线进行，高度分层
      for (let z = 0; z < lineValArr.length; z += 1) {
        // eslint-disable-next-line no-loop-func
        const currentLevelData = _.filter(res, (item) => {
          return item.center2d[1] < lineValArr[z] && item.center2d[1] > lastVal
        })
        stratifyData.push(currentLevelData)
        lastVal = lineValArr[z]
      }
      const lastLevel = _.filter(res, (item) => {
        return item.center2d[1] > lineValArr[lineValArr.length - 1]
      })
      stratifyData.push(lastLevel)
      // 对每一层的数据，进行逆向排序
      const dataWithOrder = []
      const result = []
      for (let k = 0; k < stratifyData.length; k += 1) {
        const descOrderData = stratifyData[k].sort((a, b) => {
          return b.center2d[0] - a.center2d[0] // 逆序
        })
        let orderNum = 1
        _.forEach(descOrderData, (item) => {
          item.serialNumber = orderNum
          item.level = k
          orderNum += 1
        })
        dataWithOrder.push(descOrderData)
        result.push(...descOrderData)
      }
      return {
        dataWithOrder,
        result,
      }
    },
    /**
     * @description 给图表添加层级标注
     * @param {Number} chartMaxHeight 图标y轴最大值
     * @param {Array} res 管线全量数据
     * @param {Array} lineValArr 图表中画的横线高度集合
     */
    addLevelMark(chartMaxHeight, res, lineValArr) {
      const maxLabelHeight = max(
        map(res, (it) => {
          return it.center2d[1]
        })
      )
      const markCollection = [] // 需要标记层级文字的点位集合
      let lastHeight = 0
      for (let y = 0; y < lineValArr.length; y += 1) {
        const currentHeight = (lineValArr[y] + lastHeight) / 2
        markCollection.push(currentHeight)
        lastHeight = lineValArr[y]
      }
      markCollection.push(maxLabelHeight)
      const markCollectionWithName = _.map(markCollection, (item, index) => {
        return {
          type: 'text',
          top: this.getPercentage(chartMaxHeight, item),
          left: '0%',
          z: 999,
          style: {
            fill: '#ffffff',
            text: this.getTabNameLineFeed(index),
            fontSize: 12,
            fontWeight: 500,
          },
        }
      })
      return markCollectionWithName
    },
  },
}
</script>

<style scoped lang="scss">
.operation-panel {
  .operate-handle-wrap {
    .operate-handle-btn {
      background: linear-gradient(rgba(17, 52, 68, 0.8), rgba(9, 127, 164, 0.8));
    }
    .is-active {
      background-color: #d0efff !important;
      background: linear-gradient(#1167b1, #6db5da) !important;
    }
    ::v-deep .el-color-picker,
    ::v-deep .el-color-picker__trigger {
      width: 25px !important;
      height: 25px !important;
    }
  }
  ::v-deep .el-button {
    height: 28px !important;
    border-radius: 5px !important;
    .el-loading-mask {
      background: #058ca2 !important;
      .el-loading-spinner {
        margin-top: -13px !important;
        .circular {
          height: 26px !important;
          width: 26px !important;
          .path {
            stroke: #f6f6f6 !important;
          }
        }
      }
    }
  }
  ::v-deep .el-switch__label {
    color: #fff !important;
    &.is-active {
      color: #0089ff !important;
    }
    &--left {
      margin-right: 5px !important;
    }
    &--right {
      margin-left: 5px !important;
    }
  }
  .tab-tab-warp {
    height: calc(100% - 80px);
    ::v-deep .el-tabs__content {
      height: calc(100% - 30px);
      .el-tab-pane {
        height: 100%;
      }
    }
    ::v-deep .el-tabs__header {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
